import { render } from "./ProfileMenuView.vue?vue&type=template&id=ef988672"
import script from "./ProfileMenuView.vue?vue&type=script&lang=js"
export * from "./ProfileMenuView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__